import { Component } from '@angular/core';

@Component({
  selector: 'wsb-textarea',
  templateUrl: './textarea.component.html',
  styleUrls: ['./textarea.component.scss'],
  standalone: false
})
export class TextareaComponent {
  constructor() {}
}
